import { TrackerState } from "../../types/rtk/tracker/tracker";
import { apiSlice } from "../_api/api-slice";

export const trackerEndpoint = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getTrackerState: build.query<TrackerState, void>({
      query: () => ({
        url: `/tracker/`,
        method: "get",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTrackerStateQuery
} = trackerEndpoint;